import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { UiCommand } from '@ui/cer-ui-types';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';


/*const onlySalesCmd: UiCommand = {
  id: 'onlySalesCmd', text: 'Vis alle', align: 'Right',
  iconCss: "e-menu-icon e-icons e-circle-check", tooltipText: 'Vis kun salg', target: ".e-content", visible: true
};*/

export class WarehouseOutboundCompleteTransForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'lager-leveringer', dataApiName: 'WarehouseOutboundOrderComplete', 
        primaryKey: 'id', allowEdit: false, allowCreate: false, allowDelete: false
      },
      toolbarCommands: [/*onlySalesCmd*/],
      fieldMetadata: [
        { name: 'invoicedDate', text: 'Leveret dato', format: 'DateShort', orderBy: 'Descending', orderByPriority: 1 },
        { name: 'outboundOrderNum', text: 'Forsendelse', foreignKeyType: 'warehouseOutboundOrderLookup', widthType: FieldWidthEnum.XS, orderBy: 'Descending', orderByPriority: 2 },
        { name: 'pickOrderNum', text: 'Lagerordre', widthType: FieldWidthEnum.S, visible: false },
        { name: 'orderReference', text: 'Reference', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'warehouseInvoiceNum', text: 'Lager faktura' },
        { name: 'orderedDate', text: 'Ordredato', format: 'DateShort' },
        { name: 'orderType', text: 'Ordretype', widthType: FieldWidthEnum.XS /*, filterOnClient: true, filterOperator: 'equal', filterValue: 'Direkte salg'*/ },
        { name: 'custInvoiced', text: 'Faktureret kunde', format: 'CheckBox', visible: false },
        { name: 'returnOrderType', text: 'Returordretype', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'product', fieldType: 'productLookup' },
        { name: 'productName', text: 'Titel', widthType: FieldWidthEnum.XL, foreignKeyUsing: 'product' },
        { name: 'orderedQty', text: 'Antal bestilt', format: 'Integer', visible: false },
        { name: 'invoicedQty', text: 'Antal', format: 'Integer' },
        { name: 'warehouseOwner', text: 'Lager ejer', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'warehouseItemNum', text: 'Lager varenr.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'warehouseCounterpart', text: 'Kundenr.', widthType: FieldWidthEnum.XS },
        { name: 'custDlvName', text: 'Navn lev.', widthType: FieldWidthEnum.M, visible: false },
        { name: 'custDlvStreet', text: 'Adresse lev.', widthType: FieldWidthEnum.M, visible: false },
        { name: 'custDlvZip', text: 'Postnr lev.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'custDlvCity', text: 'Bynavn lev.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'custDlvCountry', text: 'Land lev.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'custName', text: 'Kundenavn', widthType: FieldWidthEnum.M, visible: false },
        { name: 'custAddressName', text: 'Navn fak.', widthType: FieldWidthEnum.M },
        { name: 'custAddressStreet', text: 'Adresse fak.', widthType: FieldWidthEnum.M },
        { name: 'custAddressZip', text: 'Postnr fak.', widthType: FieldWidthEnum.XS },
        { name: 'custAddressCity', text: 'Bynavn fak.', widthType: FieldWidthEnum.XS },
        { name: 'custAddressCountry', text: 'Land fak.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'carrier', text: 'Transportør', widthType: FieldWidthEnum.XXS },
        { name: 'deliveryHandlingType', text: 'Ordretype', widthType: FieldWidthEnum.XXS, visible: false },
        { name: 'lineReference', text: 'Linjereference', visible: false },
        { name: 'retailPriceExTax', text: 'Udsalgspris', format: 'Amount0' },
        { name: 'discPrice', text: 'Rabat', format: 'Amount0' },
        { name: 'discPercent', text: 'Rabat%', format: 'AmountPct0' },
        { name: 'lineAmountExTax', text: 'Beløb eks. moms', format: 'Amount0' },
        { name: 'taxAmount', text: 'Momsbeløb', format: 'Amount0', visible: false },
        { name: 'created', text: 'Oprettet', tooltipText: 'Oprettet dato', allowEdit: false, format: 'DateLong', visible: false },
        { name: 'modified', text: 'Ændret', tooltipText: 'Ændret dato', allowEdit: false, format: 'DateLong', visible: false },
        { name: 'createdJobId', text: 'Oprettet job', format: 'Number', visible: false },
        { name: 'modifiedJobId', text: 'Ændret job', format: 'Number', visible: false }
      ]
    });
  }
}
